import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterBouwbedrijfPage() {
  return <ClusterPageTemplate clusterName="Bouwbedrijf" sectorName="Bouw & Installatie" sectorSlug="bouw-installatie" heroTitle="Website laten maken voor een bouwbedrijf" heroDescription="Een professionele website voor jouw aannemers- of bouwbedrijf. Wij bouwen websites die vakmanschap uitstralen en nieuwe projecten opleveren." websiteOnderdelen={[{
    icon: 'BriefcaseIcon',
    title: 'Diensten',
    description: 'Een overzichtelijke presentatie van jouw diensten, van nieuwbouw en renovatie tot onderhoud. Laat zien wat je kan.'
  }, {
    icon: 'CameraIcon',
    title: 'Projecten & Portfolio',
    description: "Visueel bewijs van je vakmanschap met voor-en-na foto's van succesvol afgeronde bouwprojecten."
  }, {
    icon: 'UsersIcon',
    title: 'Over ons',
    description: 'Bouwen is vertrouwen. Stel je team voor, toon je keurmerken en vertel het verhaal achter je bedrijf.'
  }, {
    icon: 'FileTextIcon',
    title: 'Offerte aanvragen',
    description: 'Een laagdrempelig formulier waarmee potentiële klanten direct een prijsindicatie of offerte kunnen aanvragen.'
  }]} functionaliteiten={[{
    icon: 'FileTextIcon',
    title: 'Slim offerteformulier',
    description: 'Vraag direct de juiste informatie uit (zoals afmetingen of bouwtekeningen) zodat je sneller een offerte kunt maken.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Optimalisatie voor zoektermen zoals 'aannemer [jouw regio]' zodat je gevonden wordt door klanten in de buurt."
  }, {
    icon: 'MessageSquareIcon',
    title: 'WhatsApp integratie',
    description: 'Een handige knop waarmee websitebezoekers direct een vraag kunnen stellen via WhatsApp.'
  }]} siblingClusters={[{
    name: 'Loodgieter',
    slug: 'loodgieter'
  }, {
    name: 'Elektricien',
    slug: 'elektricien'
  }, {
    name: 'Dakdekker',
    slug: 'dakdekker'
  }]} faqs={[{
    q: 'Wat kost een website voor een bouwbedrijf?',
    a: 'Een professionele website voor een bouwbedrijf begint vanaf €1.500. De exacte prijs is afhankelijk van je wensen, zoals een uitgebreide portfoliomodule of maatwerk offerteformulieren.'
  }, {
    q: 'Hoe lang duurt het om de website te bouwen?',
    a: "Gemiddeld staat de website binnen 2 tot 4 weken live. Dit is mede afhankelijk van hoe snel we foto's van jouw projecten en teksten ontvangen."
  }, {
    q: 'Kan ik zelf nieuwe projecten toevoegen?',
    a: "Ja, wij bouwen de website in WordPress. Je krijgt een korte instructie waarna je heel eenvoudig zelf nieuwe foto's en projecten kunt toevoegen aan je portfolio."
  }, {
    q: 'Word ik ook gevonden in mijn regio?',
    a: 'Zeker. We richten de website zo in dat je lokaal goed gevonden wordt in Google. We optimaliseren de teksten voor jouw specifieke werkgebied.'
  }]} data-id="element-1073" />;
}